import { RestComponent } from '../mixins/rest-component';

import './CategoryFilter.scss';
import template from './CategoryFilter.vhtml';

export default {
	name: 'CategoryFilter',
	mixins: [
		RestComponent,
	],
	template: template,
	props: ['categories', 'selected'],
	methods: {
		select(category) {
			this.updateUrl('category', category);
			this.$emit('select', category);
		},
	},
};
